import type { StoryLine } from '../types/demo'
import { AMARA_TEEN } from './speakers'

export type PrequelArtId = 'mirror' | 'question' | 'sounds' | 'purr' | 'glow' | 'accept'

export interface PrequelPanel {
  id: PrequelArtId
  title: string
  label?: string
  description: string
  lines: StoryLine[]
}

export const prequelPanels: PrequelPanel[] = [
  {
    id: 'mirror',
    title: 'Mirror',
    description:
      'Morning, 2036. A hot city wakes outside the window. Rooftops, a small plant, a cracked mirror. A black cat rests on the bed.',
    lines: [
      { kind: 'narration', text: 'Amara fixes her school tie.' },
      {
        kind: 'inner',
        speaker: AMARA_TEEN,
        text: 'Why a tie? Is school scared our necks will run away and start better lives?',
      },
      { kind: 'sound', text: 'A far-off school bell.' },
    ],
  },
  {
    id: 'question',
    title: 'The Question',
    label: 'Amara’s school memory',
    description: 'A classroom. Amara raises her hand. Other students sit at their desks.',
    lines: [
      { kind: 'speech', speaker: AMARA_TEEN, text: 'Sir, may I ask a question?' },
      {
        kind: 'speech',
        speaker: 'Teacher',
        text: 'Let us hear what you plan to waste our time with today.',
      },
      { kind: 'narration', text: 'Some students laugh. Some look down. Some whisper.' },
      { kind: 'sound', text: 'Whispers: “Always talking.” “Who does she think she is?”' },
      {
        kind: 'inner',
        speaker: AMARA_TEEN,
        text: 'Nice. A public roast before breakfast. Very normal school thing.',
      },
    ],
  },
  {
    id: 'sounds',
    title: 'Too Many Sounds',
    description: 'Back home. Amara’s shoulders are tight. Her phone sits on the table.',
    lines: [
      { kind: 'sound', text: 'Footsteps.' },
      { kind: 'sound', text: 'Bus brakes.' },
      { kind: 'sound', text: 'A phone ping.' },
      { kind: 'speech', speaker: 'Father (offscreen)', text: 'Amara. Time for school.' },
      { kind: 'narration', text: 'Amara tries to answer. No sound comes out.' },
    ],
  },
  {
    id: 'purr',
    title: 'One Sound',
    description: 'The black cat sits in Amara’s lap. Her hand rests on its fur.',
    lines: [
      { kind: 'sound', text: 'A low, steady purr.' },
      { kind: 'inner', speaker: AMARA_TEEN, text: 'One sound. Just one sound.' },
      {
        kind: 'narration',
        text: 'The sounds begin to split apart. Bus is bus. Bell is old. Cat is here.',
      },
    ],
  },
  {
    id: 'glow',
    title: 'The Glow',
    description: 'Green-gold light opens on the phone screen.',
    lines: [
      {
        kind: 'speech',
        speaker: 'Wren',
        text: 'Brains and worlds can get jumpy under pressure. Both can learn new paths.',
      },
      { kind: 'speech', speaker: AMARA_TEEN, text: 'That is sweet. Also kind of creepy.' },
    ],
  },
  {
    id: 'accept',
    title: 'Accept',
    description:
      'The cat touches the phone with one paw. The phone glow turns into an acacia leaf.',
    lines: [
      { kind: 'system', text: 'INCOMING SIGNAL. TIME-BRIDGE AVAILABLE.' },
      { kind: 'speech', speaker: AMARA_TEEN, text: 'Fine. Your plan is wild. But you commit.' },
      { kind: 'narration', text: 'Amara taps Accept.' },
      { kind: 'sound', text: 'A distant Savanna bird call.' },
    ],
  },
]

export const prequelQuietCards: string[] = [
  'At school, an adult puts Amara down for asking a question. Other students whisper.',
  'At home, lots of sounds feel too big. Her cat’s purr helps her notice one sound.',
  'A green-gold signal opens on her phone. Amara chooses to enter the Time-Bridge.',
]

export const prequelSkipRecap =
  'Amara learned to go quiet when rooms felt unsafe. Her cat’s purr helped her find one steady sound. Then the Time-Bridge opened.'

export const purrAnchorLine = 'One steady cue can make room in a loud moment.'

export const purrAnchorUnlockNote = `Added to your Field Guide: Purr Anchor. “${purrAnchorLine}”`
